import gs from './assets/goldmansachs-logo.png';
import jpm from './assets/jpmorgan-logo.png';
import cba from './assets/cba-logo.png';
import mq from './assets/macquaire-logo.png';

export default {
  name: 'Animesh Raparia',
  role: 'Head of Engineering',
  department: 'Engineering',
  pastCompanies: [gs, jpm, cba, mq],
  id: 'animesh',
};
